import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";
import { categoriesTermsApi } from "./categoriesTermsApi";

export const useCategoryTerms = (categoryId?: string | number) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.CATEGORY_TERMS(categoryId!),
    queryFn: () => categoriesTermsApi.fetchTerms(Number(categoryId)),
    enabled: !!categoryId,
  });

  return { isLoading, terms: data?.data?.terms ?? [] };
};
